import { createSlice } from "@reduxjs/toolkit";
import { response } from "express";

// Define the initial state for the offerTypesListSlice
const initialState = {
  loading: false,
  success: false,
  hasData: false,
  errorMessage: "",
  error: false,
  data: {
    offerDetails:[]
  },
};

// Create the offerTypesListSlice using createSlice
const offerTypesListSlice = createSlice({
  name: "offerTypes", // Slice name
  initialState, // Initial state
  reducers: {
    // Reducer functions to update the state
    fetchOfferTypes(state, action) {
      state.loading = true;
      state.success = false;
      state.data = initialState.data;
      state.errorMessage = "";
      
      state.error = false;
      state.hasData = false;
    },
    fetchOfferTypesSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.data = action.payload ?? {};
      state.errorMessage = "";
      state.error = false;
      state.hasData = true;
    },
    fetchOfferTypesFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.data = initialState.data;
      state.errorMessage = action.payload ?? "something went wrong";
      state.error = true;
      state.hasData = false;
    }
  },
});

// Export the reducer functions as actions
export const {
  fetchOfferTypes,
  fetchOfferTypesSuccess,
  fetchOfferTypesFailure,
} = offerTypesListSlice.actions;
// Export the reducer function itself
export default offerTypesListSlice.reducer;
